module.exports = __webpack_public_path__ + "img/motec-logo-screen.028f0fc.webp";